import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import config from '@/utils/config';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes:{
            light: {
                primary: config.colors.primary,
                secondary: config.colors.secondary,
                accent: config.colors.accent,
                error: config.colors.error,
                success: config.colors.success,
                warning: config.colors.warning,
            }
        }
    }
});
